import React from "react";

export const UserPage = () => {
   return <div>UserPage</div>;
};
